module.exports = __webpack_public_path__ + "790aed1beb1a020d5b479c8d3b5003f4.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/desktop_shop.mp4
// module id = 228
// module chunks = 0